import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomisableForm } from 'src/components/form/form/CustomisableForm';
import type { FormContextProps } from 'src/components/form/form/types';

import type { AssessmentTypeEnum } from '../../useAssessmentTypeConfig';
import { useAssessmentTypeConfig } from '../../useAssessmentTypeConfig';
import AssessmentFormFields from './AssessmentFormFields';
import type { AssessmentFormDataFields } from './assessmentSchema';
import { AssessmentFormSchema, defaultValues } from './assessmentSchema';

type Props = Omit<
  FormContextProps<AssessmentFormDataFields>,
  'defaultValues' | 'formId' | 'i18n' | 'parentType' | 'schema'
> & {
  initialTier?: number;
  riskId?: string;
  assessmentMode: AssessmentTypeEnum;
  disabledUsers?: { userId: string; reason: string }[];
};

const AssessmentForm: FC<Props> = (props) => {
  const { t } = useTranslation(['common']);
  const { user } = useRisksmartUser();
  const { parentType, taxonomyKey } = useAssessmentTypeConfig(
    props.assessmentMode
  );
  const { t: ts } = useTranslation(['common'], { keyPrefix: taxonomyKey });
  const defaultData: AssessmentFormDataFields = {
    ...defaultValues,
    Owners: [
      {
        type: 'user',
        value: user!.userId,
      },
    ],
  };

  return (
    <CustomisableForm
      {...props}
      header={t('details')}
      schema={AssessmentFormSchema}
      defaultValues={defaultData}
      i18n={{ entity_name: ts('entity_name') }}
      formId={'assessment-form'}
      parentType={parentType}
      renderTemplate={props.renderTemplate}
    >
      <AssessmentFormFields
        assessmentMode={props.assessmentMode}
        readOnly={props.readOnly}
        disabledUsers={props.disabledUsers}
      />
    </CustomisableForm>
  );
};

export default AssessmentForm;
